// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"195":"6cb5f9b1a7f60eb9","700":"63910a80970b0d07","891":"4083eacf240fdedc"}[chunkId] + ".js";
};